import { inherits as _inherits, createClass as _createClass, extends as _extends, defineProperty as _defineProperty, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import { Button } from '../Button/index.js';
import { ModalHeader } from '../ModalHeader.js';
import { i18n } from '../../i18n/translate.js';
import { AlertMessage } from '../AlertMessage/component.js';
import { formatClassName as _formatClassName } from '../../utils/formatClassName.js';

var GenericModal = /*#__PURE__*/function (_React$Component) {
  function GenericModal() {
    var _this;

    _classCallCheck(this, GenericModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _callSuper(this, GenericModal, [].concat(args));

    _defineProperty(_this, "getModalClasses", function () {
      var _this$props = _this.props,
          modalClass = _this$props.modalClass,
          size = _this$props.size,
          stickyFooter = _this$props.stickyFooter;
      return _formatClassName(["".concat(modalClass), "modal-size-".concat(size), {
        'sticky-footer': stickyFooter
      }]);
    });

    return _this;
  }

  _inherits(GenericModal, _React$Component);

  return _createClass(GenericModal, [{
    key: "renderFooter",
    value: function renderFooter() {
      var _this$props2 = this.props,
          footerCloseButton = _this$props2.footerCloseButton,
          saveButtonConfig = _this$props2.saveButtonConfig,
          stickyFooter = _this$props2.stickyFooter;
      var hasButtons = footerCloseButton && footerCloseButton.isTurnedOn || saveButtonConfig;

      if (hasButtons) {
        return /*#__PURE__*/React.createElement(Modal.Footer, {
          className: stickyFooter && 'sticky-footer'
        }, footerCloseButton.isTurnedOn && /*#__PURE__*/React.createElement(Button, _extends({
          variant: footerCloseButton.variant,
          id: footerCloseButton.id || 'generic-modal-cancel-button',
          style: footerCloseButton.bsStyle || 'secondary',
          onClick: this.props.onClose
        }, footerCloseButton === null || footerCloseButton === void 0 ? void 0 : footerCloseButton.attributes), footerCloseButton.text || i18n.t('Cancel')), saveButtonConfig && /*#__PURE__*/React.createElement(Button, _extends({
          disabled: saveButtonConfig.disabled,
          variant: saveButtonConfig.saveStyle,
          id: saveButtonConfig.id || 'generic-modal-save-button',
          onClick: saveButtonConfig.saveAction,
          style: saveButtonConfig.saveStyle || 'primary'
        }, saveButtonConfig.attributes), saveButtonConfig.saveText || i18n.t('Save')));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          bsSize = _this$props3.bsSize,
          canClose = _this$props3.canClose,
          container = _this$props3.container,
          id = _this$props3.id,
          message = _this$props3.message,
          messageType = _this$props3.messageType,
          onClose = _this$props3.onClose,
          show = _this$props3.show,
          showAlert = _this$props3.showAlert,
          title = _this$props3.title;
      var modalClassName = this.getModalClasses();
      return /*#__PURE__*/React.createElement(Modal, {
        animation: false,
        backdrop: canClose ? true : 'static',
        size: bsSize,
        className: modalClassName,
        container: container,
        id: id,
        keyboard: canClose,
        onHide: onClose,
        show: show
      }, /*#__PURE__*/React.createElement(ModalHeader, {
        onCancel: onClose,
        canClickOff: canClose,
        title: title
      }), /*#__PURE__*/React.createElement(AlertMessage, {
        message: message,
        messageType: messageType,
        visible: showAlert
      }), /*#__PURE__*/React.createElement(Modal.Body, null, this.props.children), this.renderFooter());
    }
  }]);
}(React.Component);

_defineProperty(GenericModal, "propTypes", {
  bsSize: PropTypes.string,
  canClose: PropTypes.bool,
  children: PropTypes.node,
  container: PropTypes.node,
  footerCloseButton: PropTypes.oneOfType([PropTypes.shape({
    attributes: PropTypes.object,
    variant: PropTypes.string,
    bsStyle: PropTypes.string,
    id: PropTypes.string,
    isTurnedOn: PropTypes.bool,
    text: PropTypes.string
  }), PropTypes.bool]),
  id: PropTypes.string,
  message: PropTypes.string,
  messageType: PropTypes.oneOf(['danger', 'info', 'success', 'warning']),
  modalClass: PropTypes.string,
  onClose: PropTypes.func,
  saveButtonConfig: PropTypes.shape({
    attributes: PropTypes.object,
    disabled: PropTypes.bool,
    id: PropTypes.string,
    saveAction: PropTypes.func,
    saveStyle: PropTypes.string,
    saveText: PropTypes.string
  }),
  show: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large', 'xlarge']),
  showAlert: PropTypes.bool,
  stickyFooter: PropTypes.bool,
  title: PropTypes.string
});

_defineProperty(GenericModal, "defaultProps", {
  show: true,
  showAlert: false,
  size: 'medium',
  stickyFooter: false
});

GenericModal.displayName = "GenericModal";
export { GenericModal };